import superagent from 'superagent'
import Promise from 'promise'

let config = require('config');

//let API_URL = "https://knk-test.microcms.io/api/v1/"
//let API_KEY = "86e7c1669f924bf9893a6f6a1637f1db6a92"

let API_URL = "https://cabin.microcms.io/api/v1/"
let API_KEY = "94401c71b40945f9be7b0d0d993f7a315073"

export const FETCH_TOPICS         = 'FETCH_TOPICS'
export const GET_TOPICS           = 'GET_TOPICS'
export const FETCH_TOPICS_SINGLE  = 'FETCH_TOPICS_SINGLE'
export const GET_TOPICS_SINGLE    = 'GET_TOPICS_SINGLE'

export const FETCH_MEMBER         = 'FETCH_MEMBER'
export const GET_MEMBER           = 'GET_MEMBER'
export const FETCH_MEMBER_SINGLE  = 'FETCH_MEMBER_SINGLE'
export const GET_MEMBER_SINGLE    = 'GET_MEMBER_SINGLE'

export const FETCH_WORKS         = 'FETCH_WORKS'
export const GET_WORKS           = 'GET_WORKS'
export const FETCH_WORKS_SINGLE  = 'FETCH_WORKS_SINGLE'
export const GET_WORKS_SINGLE    = 'GET_WORKS_SINGLE'

const send = (name, res) => {
  switch (name) {
    case "fetchtopics": {
      return {
        type:FETCH_TOPICS
      }
    } break;
    case "fetchtopicssingle": {
      return {
        type:FETCH_TOPICS_SINGLE
      }
    } break;
    case "fetchmember": {
      return {
        type:FETCH_MEMBER
      }
    } break;
    case "fetchmembersingle": {
      return {
        type:FETCH_MEMBER_SINGLE
      }
    } break;
    case "fetchworks": {
      return {
        type:FETCH_WORKS
      }
    } break;
    case "fetchworkssingle": {
      return {
        type:FETCH_WORKS_SINGLE
      }
    } break;
    case "gettopics": {
      return {
        type:GET_TOPICS,
        body:res.body
      }
    } break;
    case "gettopicssingle": {
      return {
        type:GET_TOPICS_SINGLE,
        body:res.body
      }
    } break;
    case "getmember": {
      return {
        type:GET_MEMBER,
        body:res.body
      }
    } break;
    case "getmembersingle": {
      return {
        type:GET_MEMBER_SINGLE,
        body:res.body
      }
    } break;
    case "getworks": {
      return {
        type:GET_WORKS,
        body:res.body
      }
    } break;
    case "getworkssingle": {
      return {
        type:GET_WORKS_SINGLE,
        body:res.body
      }
    } break;
  }
}


/* TOPICS
   ========================================================================== */

export const getTopics = () => {
  return dispatch => {
    return new Promise(() => {
      dispatch(send('fetchtopics', null))
      var url = API_URL + "topics?limit=" + 9999 + "&fields=id,title,date,image"
      superagent
      .get(url)
      .set('X-MICROCMS-API-KEY', API_KEY)
      .end((err, res) => {
        if (err) {
          console.log ("error:", err)
        }
        dispatch(send("gettopics", res))
      })
    })
  }
}

export const getTopicsById = (id) => {
  return dispatch => {
    return new Promise(() => {
      dispatch(send('fetchtopicssingle', null))
      var url = API_URL + "topics/" + id
      superagent
      .get(url)
      .set('X-MICROCMS-API-KEY', API_KEY)
      .end((err, res) => {
        if (err) {
          console.log ("error:", err)
        }
        dispatch(send("gettopicssingle", res))
      })
    })
  }
}


/* MEMBER
   ========================================================================== */

export const getMember = () => {
  return dispatch => {
    return new Promise(() => {
      var url = API_URL + "member?limit=" + 9999 + "&fields=id,name,name_en,position"
      superagent
      .get(url)
      .set('X-MICROCMS-API-KEY', API_KEY)
      .end((err, res) => {
        if (err) {
          console.log ("error:", err)
        }
        dispatch(send("getmember", res))
      })
    })
  }
}

export const getMemberById = (id) => {
  return dispatch => {
    return new Promise(() => {
      dispatch(send('fetchmembersingle', null))
      var url = API_URL + "member/" + id
      superagent
      .get(url)
      .set('X-MICROCMS-API-KEY', API_KEY)
      .end((err, res) => {
        if (err) {
          console.log ("error:", err)
        }
        dispatch(send("getmembersingle", res))
      })
    })
  }
}


/* WORKS
   ========================================================================== */

export const getWorks = (memberId = null, num = 9999) => {
  return dispatch => {
    return new Promise(() => {
      dispatch(send('fetchworks', null))
      var member = ""
      if (memberId) {
        member = "&filters=member[contains]" + memberId
      }
      var url = API_URL + "works?limit=" + num + "&fields=id,title,date,thumbnail,is_former_job,member.id,member.name_en" + member
      superagent
      .get(url)
      .set('X-MICROCMS-API-KEY', API_KEY)
      .end((err, res) => {
        if (err) {
          console.log ("error:", err)
        }
        dispatch(send("getworks", res))
      })
    })
  }
}

export const getRecentWorksByMembers = (memberId = [], num = 9999, notId = null) => {
  return dispatch => {
    return new Promise(() => {
      dispatch(send('fetchworks', null))
      var member = ""
      member = "&filters=id[not_equals]" + notId + "[and](member[contains]"
      for(var i = 0; i < memberId.length; i++) {
        if (i == 0) {
          member += memberId[i].id
        } else {
          member += "[or]member[contains]" + memberId[i].id
        }
      }
      member += ")"
      var url = API_URL + "works?limit=" + num + "&fields=id,title,date,thumbnail,is_former_job,member.id,member.name_en" + member
      superagent
      .get(url)
      .set('X-MICROCMS-API-KEY', API_KEY)
      .end((err, res) => {
        if (err) {
          console.log ("error:", err)
        }
        dispatch(send("getworks", res))
      })
    })
  }
}
export const getWorksById = (id) => {
  return dispatch => {
    return new Promise(() => {
      dispatch(send('fetchworkssingle', null))
      var url = API_URL + "works/" + id
      superagent
      .get(url)
      .set('X-MICROCMS-API-KEY', API_KEY)
      .end((err, res) => {
        if (err) {
          console.log ("error:", err)
        }
        dispatch(send("getworkssingle", res))
      })
    })
  }
}




// WEBPACK FOOTER //
// ./actions/const.js